/**
 * Zweck: Animiert erfolgreich hinzugefügte Shop-Positionen von ihrem Ursprung zum sichtbaren Navbar-Warenkorb.
 */
import {Injectable} from '@angular/core';
import {AppEventService} from './app.event.service';

/** Mittelpunkt eines Shop-Buttons oder Mengenfelds im Viewport. */
export interface WarenkorbFlightOrigin {
  /** Horizontale Viewport-Koordinate. */
  x: number;
  /** Vertikale Viewport-Koordinate. */
  y: number;
}

@Injectable({providedIn: 'root'})
/** Animiert Warenkorb-Zugänge unabhängig vom Navbar-Layout. */
export class AppWarenkorbFlightService {
  /** Verwendet GUI-Ereignisse für die Rückmeldung am Ziel. */
  constructor(private esvc: AppEventService) {
  }

  /** Startet einen Flug je gültigem Ursprung nach einem erfolgreichen Hinzufügen. */
  flyFrom(origins: WarenkorbFlightOrigin | WarenkorbFlightOrigin[]): void {
    if (typeof document === 'undefined' || typeof window === 'undefined'
      || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    const sourcePoints = (Array.isArray(origins) ? origins : [origins])
      .filter(origin => origin && Number.isFinite(origin.x) && Number.isFinite(origin.y));
    const target = Array.from(document.querySelectorAll<HTMLElement>(
      'app-warenkorb-menu .warenkorb-menu-cart-button'
    )).map(button => button.getBoundingClientRect())
      .find(rect => rect.width > 0 && rect.height > 0);
    if (!target || sourcePoints.length === 0) {
      return;
    }

    this.esvc.addGuiEvent('warenkorb_flight_started');
    sourcePoints.forEach((origin, index) => {
      const dx = target.left + target.width / 2 - origin.x;
      const dy = target.top + target.height / 2 - origin.y;
      const token = document.createElement('span');
      token.textContent = '+';
      token.setAttribute('aria-hidden', 'true');
      token.style.cssText = `position:fixed;left:${origin.x - 14}px;top:${origin.y - 14}px;z-index:2147483000;`
        + 'display:flex;align-items:center;justify-content:center;width:28px;height:28px;'
        + 'border-radius:7px;background:#288d45;color:white;font-size:24px;font-weight:700;'
        + 'box-shadow:0 0 0 3px white,0 3px 18px rgba(0,0,0,.32);pointer-events:none;';
      document.body.appendChild(token);
      const delay = Math.min(index * 55, 300);
      token.animate([
        {opacity: 1, transform: 'translate(0, 0) scale(1)'},
        {opacity: 1, transform: `translate(${dx / 2}px, ${dy / 2 - Math.min(80, Math.max(20, Math.abs(dy) * 0.12))}px) scale(1.1)`, offset: .5},
        {opacity: 1, transform: `translate(${dx}px, ${dy}px) scale(.6)`, offset: .9},
        {opacity: 0, transform: `translate(${dx}px, ${dy}px) scale(.3)`}
      ], {duration: 1000, delay, easing: 'cubic-bezier(.22, .8, .25, 1)', fill: 'forwards'});
      setTimeout(() => {
        token.remove();
        this.esvc.addGuiEvent('warenkorb_flight_arrived');
      }, 1000 + delay);
    });
  }
}
